import renderHTML from "react-render-html"

export const domElementToReactElement = (element) => {
  const elementStr = element.innerHTML.replace(/>\s+</g, "><").trim()
  return renderHTML(elementStr)
}
export const htmlStringToReactElement = (string) => {
  const htmlStr = string.replace(/>\s+</g, "><").trim()
  return renderHTML(htmlStr)
}

export const decodeHTMLEntities = (text) => {
  var textArea = document.createElement("textarea")
  textArea.innerHTML = text
  return textArea.value
}
